export * from './menu';
export * from './latestUpdatesBox';
export * from './profileDataBox';
export * from './userInfoBox';

import { FC } from 'react';
import { PageWithSidebar } from '../pageWithSidebar';
import { MenuConfig, PageMenu } from './menu';

type Props = {
  menuConfig: MenuConfig;
  elementAboveMenu?: JSX.Element;
  elementBelowMenu?: JSX.Element;
  rightColumn?: JSX.Element;
  stickyThresholdSize?: number;
};

export const PageWithMenu: FC<React.PropsWithChildren<Props>> = ({
  menuConfig,
  elementAboveMenu,
  elementBelowMenu,
  stickyThresholdSize,
  rightColumn,
  children
}) => {
  stickyThresholdSize = stickyThresholdSize ?? 32;

  const leftColumn = (
    <>
      {!!elementAboveMenu && elementAboveMenu}
      <PageMenu config={menuConfig} />
      {!!elementBelowMenu && elementBelowMenu}
    </>
  );

  return (
    <PageWithSidebar
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      stickyThresholdSize={stickyThresholdSize}
    >
      {children}
    </PageWithSidebar>
  );
};
